import { BASE_DEPLOYMENT_CHAIN_ID, EVM_CONFIG } from "../config";

/**
 * Every .stealth handle lives in one registry: the Base deployment's
 * AnonymousHandleRegistry. A name taken from any network is taken on all of
 * them. Each network then adds its own receiving entry to the handle's record,
 * because every network derives its own private keys.
 */
export const HANDLE_REGISTRY_CHAIN_ID: number = BASE_DEPLOYMENT_CHAIN_ID;

export function handleRegistryAddress(): string {
  const value = String(
    process.env.REACT_APP_BASE_STEALTH_ANON_REGISTRY_ADDRESS || "",
  )
    .trim()
    .toLowerCase();
  return /^0x[0-9a-f]{40}$/.test(value) ? value : "";
}

/** Networks a handle can receive on; the first is where v1 records live.
 * Must match the data API's defaults for the registry chain. */
function handleNetworksFor(chainId: number): readonly string[] {
  if (chainId === 84532)
    return ["base-sepolia", "dogeos-chikyu", "solana-devnet"];
  if (chainId === 8453) return ["base", "dogeos", "solana"];
  return [];
}

export const HANDLE_NETWORKS = handleNetworksFor(HANDLE_REGISTRY_CHAIN_ID);
export const HANDLE_HOME_NETWORK: string = HANDLE_NETWORKS[0] ?? "";

/** The network this page receives on, as named in handle records. Read
 * defensively: modules importing this load before any handle code runs. */
export const HANDLE_PAGE_NETWORK: string = EVM_CONFIG?.NETWORK?.key ?? "";

const NETWORK_LABELS: Record<string, string> = {
  base: "Base",
  "base-sepolia": "Base Sepolia",
  dogeos: "DogeOS",
  "dogeos-chikyu": "DogeOS Chikyu",
  solana: "Solana",
  "solana-devnet": "Solana Devnet",
};

export function handleNetworkLabel(network: string): string {
  return NETWORK_LABELS[network] ?? network;
}

/** Handles work on this page when it is one of the registry's networks. */
export function handlesSupportedHere(network = HANDLE_PAGE_NETWORK): boolean {
  return !!handleRegistryAddress() && HANDLE_NETWORKS.includes(network);
}
